(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["New-blog"] && !Shopify.designMode) return;
  try {
    
function updateMobileGrid() {
  const grids = document.querySelectorAll('.blog-grid');
  const mobileWidth = 768;
  grids.forEach(grid => {
    const mobileCols = grid.getAttribute('data-mobile-columns') || 1;
    const desktopColsMatch = grid.getAttribute('style').match(/repeat\((\d+), 1fr\)/);
    const desktopCols = desktopColsMatch ? desktopColsMatch[0] : `repeat(2, 1fr)`;
    if (window.innerWidth <= mobileWidth) {
      grid.style.gridTemplateColumns = `repeat(${mobileCols}, 1fr)`;
    } else {
      grid.style.gridTemplateColumns = desktopCols;
    }
  });
}
window.addEventListener('resize', updateMobileGrid);
document.addEventListener('DOMContentLoaded', updateMobileGrid);

  } catch(e) { console.error(e); }
})();
})();
